import { Box, Switch, Typography } from '@mui/material';
import { CustomTooltip } from 'src/content/keywordResearch/CustomTooltip';
import HelpIcon from '@mui/icons-material/Help';
import { CreateCampaignHeaderStyles } from '../styles/createCampaignHeader';
import { useState, memo } from 'react';

export const CreateCampaignHeader = memo(() => {
  const [hideLocation, setHideLocation] = useState(false);

  return (
    <Box sx={CreateCampaignHeaderStyles.container}>
      <Box sx={CreateCampaignHeaderStyles.titleContainer}>
        <Typography sx={CreateCampaignHeaderStyles.title}>
          Create a Campaign
        </Typography>
        <CustomTooltip
          title={
            <Box>
              <Typography sx={CreateCampaignHeaderStyles.tooltipText}>
                Create a citation campaign to improve your local SEO presence. This campaign will help you create new business citations, fix inaccurate or outdated listings, remove duplicates, and submit your business information to trusted data aggregators.
              </Typography>
            </Box>
          }
          placement="bottom"
          arrow
        >
          <HelpIcon sx={CreateCampaignHeaderStyles.helpIcon} />
        </CustomTooltip>
      </Box>
      <Box sx={CreateCampaignHeaderStyles.locationToggleContainer}>
        <Typography sx={CreateCampaignHeaderStyles.locationToggleLabel}>
          Hide My Location
        </Typography>
        <Switch
          checked={hideLocation}
          onChange={(e) => setHideLocation(e.target.checked)}
          sx={CreateCampaignHeaderStyles.switch}
        />
      </Box>
    </Box>
  );
});

